<base-infinite-scroll (scrollDownEvent)="onScrollDown()">
  <ng-container *ngIf="!!inquiry.directlyInquired && !!offers.length && !hasDirectlyInquiredOffers">
    <base-empty-list-row
      message="inquiry.directlyInquiredWasNotOffered"
      [hideBackgroundImage]="true"
    ></base-empty-list-row>
    <base-customer-alternative-offers-headline
      title="inquiry.alternativeOffers"
      icon="fa-circle-exclamation"
    ></base-customer-alternative-offers-headline>
  </ng-container>
  <div
    class="position-relative"
    *ngFor="let offer of offers; let first = first; trackBy: trackByOffer"
  >
    <span
      *ngIf="offer.data.profile.isDirectlyInquired"
      class="directly-inquired-label-customer"
    >
      {{ 'inquiry.directlyInquired' | translate }}
    </span>
    <base-customer-inquiry-offer
      [ngClass]="{
        'inquiry-teaser-selected': offer.data.isSelected,
        'offer-sent': offer.data.status === offerStatuses.open,
        'offer-declined': offer.data.status === offerStatuses.declined,
        'offer-confirmed': offer.data.status === offerStatuses.confirmed,
        'offer-needs-confirmation': offer.data.status === offerStatuses.needsConfirmation,
        'offer-preselected':
          isOfferPreselectionAllowed &&
          offer.data.status === offerStatuses.open &&
          offer.data.preselected &&
          !offer.data.workCouncilStatus,
        'offer-work-council-approved':
          offer.data.workCouncilStatus === offerWorkCouncilStatuses.APPROVED ||
          offer.data.workCouncilStatus === offerWorkCouncilStatuses.AUTO_APPROVED ||
          offer.data.workCouncilStatus === offerWorkCouncilStatuses.NOTED,
        'offer-work-council-disapproved': offer.data.workCouncilStatus === offerWorkCouncilStatuses.DISAPPROVED
      }"
      class="inquiry-teaser inquiry-employee-container p-0"
      [offer]="offer"
      [modalRef]="modalRef"
      [canAcceptOffers]="canAcceptOffers"
      [isOfferPreselectionAllowed]="isOfferPreselectionAllowed"
      [assignmentInfo]="assignmentInfo"
      [hasAdminAssignmentsPermission]="hasAdminAssignmentsPermission"
      [inquiry]="inquiry"
      [shiftTimesWithFlex]="shiftTimesWithFlex"
    ></base-customer-inquiry-offer>
    <base-customer-alternative-offers-headline
      *ngIf="!!inquiry.directlyInquired && hasDirectlyInquiredOffers && offers.length > 1 && first"
      title="inquiry.alternativeOffers"
      icon="fa-circle-exclamation"
    ></base-customer-alternative-offers-headline>
  </div>
</base-infinite-scroll>

<base-empty-list-row
  *ngIf="!offers.length"
  message="dashboardInfo.noOffers"
></base-empty-list-row>
